// Primitive 14 — Sidebar et Topbar.
// Transposition directe du bloc héros du site : fond bleu nuit, nom de
// marque en capitales espacées, sous-titre cyan, barre cyan de 3 px sur
// l'entrée active.
//
// Le nom de l'utilisateur vient de la session, jamais d'une constante
// écrite en dur — c'était la dernière ligne de la liste « ce qu'on ne
// refait pas » du design system.

import { NavLink } from 'react-router';
import Button from './Button.jsx';
import { useSession } from '../lib/session.jsx';
import logoNeg from '@branding/logo-mertens-neg.png';

const ROLE_LABELS = { admin: 'Administrateur', user: 'Deviseur' };

export function Shell({ nav, title, actions, children }) {
  const { user, logout } = useSession();

  return (
    <div className="shell">
      <a className="skip-link" href="#contenu">
        Aller au contenu
      </a>

      <nav className="sidebar" aria-label="Navigation principale">
        <div className="sidebar__brand">
          {/* Version négative : la sidebar est sur bleu nuit. Le logo
              porte déjà le nom, donc le texte alternatif ne le répète
              pas dans un élément voisin — il EST le nom. */}
          <img className="sidebar__logo" src={logoNeg} alt="Mertens Mécanique" />
          <span className="sidebar__brand-sub">Devis</span>
        </div>

        <ul className="sidebar__nav">
          {nav.map((item) => (
            <li key={item.to}>
              <NavLink className="sidebar__link" to={item.to} end={item.end}>
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="sidebar__foot">
          <p className="sidebar__user">{user?.display_name}</p>
          <p className="sidebar__role">{ROLE_LABELS[user?.role] ?? user?.role}</p>
        </div>
      </nav>

      <div className="main">
        <header className="topbar">
          <h1>{title}</h1>
          <div className="topbar__actions">
            {actions}
            <Button variant="ghost" size="sm" onClick={logout}>
              Se déconnecter
            </Button>
          </div>
        </header>
        <main className="page" id="contenu">
          <div className="page__inner">{children}</div>
        </main>
      </div>
    </div>
  );
}

export default Shell;
